import React from 'react'
import { IntegratedPaymentOption, SalePayment } from './types'

type Props = {
  paymentOptions: IntegratedPaymentOption
  onSuccess?: (result: SalePayment) => void
  onClose: () => void
}

export const IntegratedPayment = ({
  paymentOptions,
  onSuccess,
  onClose,
}: Props) => {
  // Placeholder for Swiper payment implementation
  return <></>
}
